import axios from '@axios'
import { getData } from '@core/utils/http/general'
import store from '@/store'

export default {
  namespaced: true,
  state: {
    calendarOptions: [],
    selectedCalendars: [],
    calendarFiltros: [],
    selectedFiltros: [],
  },
  getters: {},
  mutations: {
    SET_SELECTED_EVENTS(state, val) {
      state.selectedCalendars = val
    },
    SET_SELECTED_FILTROS(state, val) {
      state.selectedFiltros = val
    },
    SET_CALENDAR_OPTIONS(state, val) {
      state.calendarOptions = val
    },
    SET_CALENDAR_FILTROS(state, val) {
      state.calendarFiltros = val
    },
  },
  actions: {
    async fetchEvents(ctx, {
      calendars, filtros, start, end,
    }) {
      if (!calendars.length) {
        return []
      }

      const token = store.state?.cuenta?.session?.token
      if (!token) return Promise.resolve([])

      return getData(
        {
          action: 8,
          token,
          start,
          end,
          calendars: JSON.stringify(calendars),
          filtros: JSON.stringify(filtros),
        },
        'wscalendario',
      ).then(response => {
        if (response && response.status === 200 && response.data.status === 200) {
          return response.data.data || []
        }
        throw new Error(response.data?.message || 'Error al cargar los eventos de calendario')
      }).catch(error => {
        throw new Error(error || 'Error en el servidor al cargar los eventos de calendario')
      })
    },
    async fetchCalendarOptions(ctx) {
      const token = store.state?.cuenta?.session?.token
      if (!token) return Promise.resolve([])

      return getData(
        {
          action: 7,
          token,
        },
        'wscalendario',
      ).then(response => {
        if (response && response.status === 200) {
          const calendars = response.data.tipos || []
          const calendarFiltros = response.data.filtros || []
          ctx.commit('SET_CALENDAR_OPTIONS', calendars)
          ctx.commit('SET_CALENDAR_FILTROS', calendarFiltros)

          // Seleccionar todos por defecto
          ctx.commit(
            'SET_SELECTED_EVENTS',
            calendars.map(c => c.id),
          )
          ctx.commit('SET_SELECTED_FILTROS', calendarFiltros.map(c => c.id))

          return calendars
        }

        throw new Error(response.message || 'Error al cargar las opciones de calendario')
      }).catch(error => {
        ctx.commit('SET_CALENDAR_OPTIONS', [])
        ctx.commit('SET_SELECTED_EVENTS', [])
        ctx.commit('SET_CALENDAR_FILTROS', [])
        ctx.commit('SET_SELECTED_FILTROS', [])

        throw new Error(error || 'Error en el servidor al cargar las opciones de calendario')
      })
    },

    addEvent(ctx, { event }) {
      return new Promise((resolve, reject) => {
        axios
          .post('/apps/calendar/events', { event })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    updateEvent(ctx, { event }) {
      return new Promise((resolve, reject) => {
        axios
          .post(`/apps/calendar/events/${event.id}`, { event })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    removeEvent(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axios
          .delete(`/apps/calendar/events/${id}`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
  },

}
